import React from "react";
import "./ContentPage.css";

const termsList = [
  {
    title: "Eligibility",
    content:
      "Applicants must be 18 years or older to apply for loans through Core Bankers. Loan approvals are subject to lender policies, creditworthiness, and financial history. Core Bankers does not guarantee loan approvals, as final decisions rest with the respective banks/NBFCs. Applicants must provide valid identification and proof of income to be considered for loan processing.",
  },
  {
    title: "Loan Application Process",
    content:
      "Applicants must provide accurate and complete information during the loan application process. Core Bankers acts as an intermediary and does not directly sanction loans. Loan processing time varies based on lender policies, applicant eligibility, and document verification. Any discrepancies in the provided information may result in delays or rejection of the application.",
  },
  {
    title: "Fees & Charges",
    content:
      "Core Bankers does not charge applicants any upfront fees for loan applications. Processing fees, interest rates, and other charges are determined by the respective banks/NBFCs. Applicants should review lender-specific terms before proceeding. Late payment penalties, foreclosure charges, and additional costs may apply based on lender policies.",
  },
  {
    title: "Privacy & Data Protection",
    content:
      "We prioritize data security and comply with applicable privacy laws. Personal information shared during loan applications is used solely for processing purposes. Core Bankers does not sell or share applicant data with unauthorized third parties. We implement encryption, secure servers, and compliance with industry standards to protect user data.",
  },
  {
    title: "Limitation of Liability",
    content:
      "Core Bankers is not responsible for loan rejections, delays, or lender decisions. We do not provide financial advice; applicants must assess loan terms independently. Any disputes regarding loan terms must be addressed directly with the respective lender. Core Bankers is not liable for any financial losses incurred due to loan agreements.",
  },
  {
    title: "User Responsibilities",
    content:
      "Applicants must ensure all provided information is truthful and accurate. Misrepresentation may lead to loan rejection or legal consequences. Users must comply with lender policies, repayment schedules, and financial obligations. Failure to adhere to loan terms may result in penalties or legal action by the lender.",
  },
  {
    title: "Third-Party Services",
    content:
      "Core Bankers may provide links to third-party services for loan processing and financial assistance. We are not responsible for the accuracy or reliability of third-party content. Users should review third-party terms before engaging and ensure compliance with lender agreements.",
  },
  {
    title: "Termination of Services",
    content:
      "Core Bankers reserves the right to terminate services for fraudulent applications, policy violations, or misuse of loan facilitation services. Users engaging in misconduct may be blacklisted from future applications. Any attempt to manipulate loan approvals or provide false documentation will result in immediate termination of services.",
  },
  {
    title: "Governing Law",
    content:
      "These Terms & Conditions are governed by Indian law. Any disputes must be resolved in accordance with applicable legal procedures. Users must comply with financial regulations, RBI guidelines, and lender-specific policies while engaging with Core Bankers’s services.",
  },
  {
    title: "Amendments & Updates",
    content:
      "Core Bankers reserves the right to modify these Terms & Conditions at any time. Users should review updates periodically to stay informed. Any significant modifications will be communicated via email or website notifications to ensure transparency and user awareness.",
  },
];

const TermsConditions = () => {
  return (
    <main className="content-page">
      <section className="content-hero">
        <div className="content-hero-inner">
          <span className="cb-section-label">Legal</span>
          <h1>Terms & Conditions</h1>
          <p>Please read these Terms & Conditions carefully before using our services.</p>
        </div>
      </section>

      <div className="content-body">
        {termsList.map((term) => (
          <section className="content-section" key={term.title}>
            <h2>{term.title}</h2>
            <p>{term.content}</p>
          </section>
        ))}
        <p className="content-disclaimer">
          Disclaimer: Core Bankers operates as a Direct Selling Agent (DSA) under VedhaNirvana Private Limited,
          facilitating loan services from various banks and NBFCs. Loan approvals and terms are subject to lender policies.
        </p>
      </div>
    </main>
  );
};

export default TermsConditions;
